var MESSAGE_TYPES = {
  // BE defined types
  text: 1,
  rating: 3,
  multiSelect: 4,
  imageSelect: 2,
  textResponse: 5,
  imageWithTextCard: 6,
  designerCard: 7,
  requestRevision: 9,
  buttonWithLink: 10,
  singleSelect: 11,
  // Client side defined types
  redesignRequest: 9998,
  filesMessage: 9999,
  dateMessage: 10000
};
var MESSAGE_GROW_ANIMATION_TIME = 300; // in ms

var MESSAGE_RESPONSE_DELAY = 500; // in ms

var BAD_FILE_TYPE_MODAL_TITLE = 'File unsupported';
var BAD_FILE_TYPE_CONFIRM_LABEL = 'Ok';
var SKIP_REASON_SKIP_FOR_STAFF = 1;
var SKIP_REASON_REMOVED = 2;
var SUPPORTED_FILE_TYPES = '.pdf, .png, .jpeg, .jpg, .gif, .heic, .mp4, .mov, and .psd';
var SUPPORTED_MIME_TYPES = 'application/x-photoshop, application/photoshop, application/pdf, application/psd, image/heic, image/heif, image/jpeg, image/png, image/psd, image/gif, image/vnd.adobe.photoshop, video/mp4, video/mov, video/mpeg, video/quicktime';
var MESSENGER_CONVERSATION_VIEW_MESSAGES = 'messages';
var MESSENGER_CONVERSATION_VIEW_PINNED = 'pinned';
export { BAD_FILE_TYPE_CONFIRM_LABEL, BAD_FILE_TYPE_MODAL_TITLE, MESSAGE_GROW_ANIMATION_TIME, MESSAGE_RESPONSE_DELAY, MESSAGE_TYPES, MESSENGER_CONVERSATION_VIEW_MESSAGES, MESSENGER_CONVERSATION_VIEW_PINNED, SKIP_REASON_REMOVED, SKIP_REASON_SKIP_FOR_STAFF, SUPPORTED_FILE_TYPES, SUPPORTED_MIME_TYPES };